
import { Options, setup, Vue } from "vue-class-component";
import { useStore } from "vuex";
import HomePage from "./components/HomePage.vue";
import { key } from "./store";

@Options({
  components: {
    HomePage,
  },
  mounted() {
    const store = useStore(key);
    //if (localStorage.getItem("sessionId") === null) {
    if (store.state.sessionId === null) {
      store.dispatch("createSession");
    }
  },
})
export default class App extends Vue {}
